import React, { useEffect, useRef, useState } from "react";
import map_image from "../../assets/images/webp/map_img.jpg";
import map_loction_icon from "../../assets/images/svg/map_loction_icon.svg";
import { tiltHandlers } from "../hkianimatica/useTilt";
import "../../styles/animatica.css";
import "../../styles/skilling.css";

const locations = [
  { name: "J&K", top: "10%", left: "22%", cities: [] },
  { name: "Uttarakhand", top: "22%", left: "35%", cities: ["Haridwar"] },
  {
    name: "UP",
    top: "34%",
    left: "40%",
    cities: ["Lucknow", "Noida", "Moradabad", "Ghaziabad", "Pilibhit", "Varanasi"],
  },
  { name: "MP", top: "48%", left: "33%", cities: ["Bhopal"] },
  { name: "Bihar", top: "39%", left: "57%", cities: ["Patna"] },
  {
    name: "Haryana",
    top: "27%",
    left: "27%",
    cities: ["Gurugram", "Sirsa", "Chandigarh", "Mohali"],
  },
  { name: "Punjab", top: "21%", left: "24%", cities: ["Ludhiana"] },
  { name: "Rajasthan", top: "36%", left: "20%", cities: ["Jaipur", "Ajmer", "Alwar"] },
  { name: "Gujarat", top: "48%", left: "12%", cities: ["Ahmedabad"] },
  { name: "Maharashtra", top: "60%", left: "25%", cities: ["Mumbai", "Pune"] },
];

const OurPresence = () => {
  const [hoveredState, setHoveredState] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="op-section skilling-home-section py-5">
      <div className="an-glow an-glow-left" />
      <div className="an-glow an-glow-right" />
      <div className="container position-relative">
        <div className="text-center mb-4">
          <span className="an-reveal an-reveal-d1 an-eyebrow justify-content-center w-100">
            Pan-India Network
          </span>
          <h4 className="an-reveal an-reveal-d2 fs_35 fw-bold ff_s mb-0 text-navy">
            Our <span className="text-white">Presence</span>
          </h4>
          <p
            className="an-reveal an-reveal-d3 mt-2 fs_18 ff_n mb-0 skilling-subtitle"
          >
            HKI Media's extensive presence across India connects us to both
            metropolitan and regional media hubs.
          </p>
        </div>
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-6 pe-md-4 an-reveal an-reveal-d1">
            <div className="op-map-wrap an-tilt an-glass" {...tiltHandlers}>
              <img loading="lazy" decoding="async" className="w-100" style={{ borderRadius: "14px" }} src={map_image} alt="Map of HKI Media's presence across India" />
              {locations.map((location) => (
                <div
                  key={location.name}
                  className={`op-marker cursor-pointer ${hoveredState === location.name ? "is-active" : ""}`}
                  style={{ position: "absolute", top: location.top, left: location.left }}
                  onMouseEnter={() => setHoveredState(location.name)}
                  onMouseLeave={() => setHoveredState(null)}
                >
                  <img loading="lazy" decoding="async" src={map_loction_icon} alt={location.name} />
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 mt-5 mt-lg-0">
            <div className="an-reveal an-reveal-d4 op-grid">
              {locations.map((location) => (
                <div
                  key={location.name}
                  className={`op-card ${hoveredState === location.name ? "is-active" : ""}`}
                  onMouseEnter={() => setHoveredState(location.name)}
                  onMouseLeave={() => setHoveredState(null)}
                >
                  <h6 className="op-card-title">{location.name}</h6>
                  <div className="op-panel-cities">
                    {location.cities.length ? (
                      location.cities.map((city) => (
                        <span key={city} className="op-panel-city">
                          {city}
                        </span>
                      ))
                    ) : (
                      <span className="op-panel-city">Coming soon</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPresence;
